<template>
    <div>
        <zm-table :data="list" v-loading="loading" :init-displayed-column="initDisplayedColumn">
            <zm-table-column prop="id" label="id"></zm-table-column>
            <zm-table-column prop="requestIp" label="requestIp"></zm-table-column>
            <zm-table-column prop="ip" label="ip"></zm-table-column>
            <zm-table-column prop="clientName" label="clientName"></zm-table-column>
            <zm-table-column prop="hostName" label="hostName"></zm-table-column>
            <zm-table-column label="tags" prop="tags">
                <template slot-scope="scope">
                    <zm-tag v-for="item in scope.row.tags" :key="item" type="" size="mini">{{ item }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column prop="globalHandlers" label="globalHandlers">
                <template slot-scope="scope">
                    <zm-tooltip placement="right"
                    v-if="scope.row.globalHandlers && scope.row.globalHandlers.length">
                        <div slot="content">
                            <p v-for="item in scope.row.globalHandlers" :key="item">{{ item }}</p>
                        </div>
                        <zm-tag size="medium" type="">show</zm-tag>
                    </zm-tooltip>
                    <span v-else></span>
                </template>
            </zm-table-column>
            <zm-table-column prop="createdTime" label="createdTime" :formatter="setTime"></zm-table-column>
            <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime"></zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
    </div>
</template>
<script>
import { listPoolClient } from '@/api/smart'
export default {
    name: 'poolclient',
    data () {
        return {
            initDisplayedColumn: {
                key: 'poolclient',
                props: ['id', 'ip', 'hostName', 'tags', 'globalHandlers', 'requestIp', 'clientName', 'createdTime', 'modifiedTime']
            },
            loading: false,
            serviceId: '',
            list: [],
            poolList: [],
            tags: [],
            visible: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        this.poolId = this.$route.params.poolId
        this.fetchData()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        fetchData () {
            this.loading = true
            const params = {
                size: this.pageable.size,
                page: this.pageable.page - 1
            }
            listPoolClient(this.poolId, params).then(response => {
                const { content, total } = response
                this.list = content.map(item => {
                    const data = item.result
                    data.tags = item.tags
                    return data
                })
                this.pageable.total = total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
